export default class ShippingLabel{
    packageNo : string;
    soCode : string;
    warehouseCode : string;
    warehouseName : string;
    warehousePhone:string;
    warehouseAddress : string;
    clientCode : string;
    clientName : string;
    shippingName : string;
    shippingPhone : string;
    shippingAddress : string;
    shippingNote:string;
    isGroupPackage: boolean;
    sumPackage:number;
}